import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=5a07657c"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=5a07657c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports